export default "__VITE_ASSET__DP6mMh1X__"